enum MimeType {
    OGG = "audio/ogg",
    WAV = "audio/wav",
    WEBM = "audio/webm",
}

export { MimeType };
